import styled from 'styled-components';
import theme from '../../theme';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 20px);
    max-width: 600px;
    height: 36px;
    border-radius: 90px;
    background-color: ${theme.white};
    padding: 7px 10px;
    margin-top: 10px;

    svg {
        cursor: pointer;
    }
`;


const Title = styled.header`
    font-size: 18px;
    font-weight: 700;
    line-height: 21.09px;
    color: ${theme.textDark};
`;

export { Container, Title };